"use client";
//#region packages/@mantine/core/src/components/Menu/Menu.module.css
var Menu_module_default = {
	"dropdown": "m_dc9b7c9f",
	"label": "m_9bfac126",
	"divider": "m_efdf90cb",
	"item": "m_99ac2aa1",
	"search": "m_ef8769b6",
	"itemLabel": "m_5476e0d3",
	"itemIndicator": "m_8395186e",
	"itemSection": "m_8b75e504",
	"chevron": "m_b85b0bed"
};
//#endregion
export { Menu_module_default as default };

//# sourceMappingURL=Menu.module.mjs.map